/**
 * A plugin's record id, `<kind>/<name>`: what the record panel, the
 * palette, and the full-page map name a plugin by.
 */
import type { CatalogKind } from '@optum/api-client/types';

const KINDS: readonly CatalogKind[] = ['capabilities', 'tools'];

/** `capabilities/contextual-qa` → the pair, or null when the kind is not one. */
export function parsePluginId(id: string): { kind: CatalogKind; name: string } | null {
  const slash = id.indexOf('/');
  if (slash <= 0) return null;
  const kind = id.slice(0, slash);
  const name = id.slice(slash + 1);
  if (!(KINDS as readonly string[]).includes(kind) || !name) return null;
  return { kind: kind as CatalogKind, name };
}

export function pluginId(kind: CatalogKind, name: string): string {
  return `${kind}/${name}`;
}
